export const RowActionTiers = {
  Tier1: 'TIER1',
  Tier2: 'TIER2',
  Tier3: 'TIER3',
  Tier4: 'TIER4',
  Tier5: 'TIER5',
  Tier6: 'TIER6',
} as const;

export const Tier1RowActions = {
  Details: 'DETAILS',
  Rename: 'RENAME',
} as const;

export const Tier2RowActions = {
  Add: 'ADD_',
} as const;

export const Tier3RowActions = {
  Delete: 'DELETE',
  Edit: 'EDIT',
} as const;

export const Tier4RowActions = {
  Activate: 'ACTIVATE',
  Clone: 'CLONE',
  Create: 'CREATE_',
  Deactivate: 'DEACTIVATE',
  Duplicate: 'DUPLICATE',
  Expire: 'EXPIRE',
  Export: 'EXPORT',
  Impersonate: 'IMPERSONATE',
  Logout: 'LOGOUT',
  Override: 'OVERRIDE',
  Pause: 'PAUSE',
  Pending: 'PENDING',
  Reactivate: 'REACTIVATE',
  ResetPassword: 'RESET_PASSWORD',
  Resume: 'RESUME',
  Show: 'SHOW_',
  ShareAudience: 'SHARE_AUDIENCE',
  Troubleshoot: 'TROUBLESHOOT',
  Unpublish: 'UNPUBLISH',
  UseAsTemplate: 'USE_AS_TEMPLATE',
  UseSharedTargeting: 'USE_SHARED_TARGETING',
} as const;

export const Tier5RowActions = {
  ManageSignalControl: 'MANAGE_SIGNAL_CONTROL',
  ShowSimilar: 'SHOW_SIMILAR',
  CreateLaLSegments: 'CREATE_LAL_SEGMENTS',
} as const;

export const Tier6RowActions = {
  CheckTargeting: 'CHECK_TARGETING',
};
